import { DatabaseRecord } from "../repos/table.repo";
import dayjs, { Dayjs } from "dayjs";

export interface ArticleModel extends DatabaseRecord {
    name: string;
    summary?: string;
    contents?: string;
    image?: string;
    absImage?: string;
    video?: string;
    catId?: string;
    urlName: string;
    langCode?: string;
    tags?: string;
    pubYN: boolean;
    isHot: boolean;
    publishDate?: string | Dayjs;
    priority?: number;
    metaTitle?: string;
    metaDescription?: string;
    metaKeyword?: string;
    metaTag?: string;
    waterFactoryId?: string;
    createDate?: string;
    modifyDate?: string;
}

export class ArticleModelFactory {
    static getEmpty(): ArticleModel {
        return {
            id: "",
            name: "",
            summary: "",
            contents: "",
            image: "",
            urlName: "",
            langCode: "vi",
            pubYN: false,
            isHot: false,
            publishDate: dayjs(),
            priority: 0,
        };
    }
}
